<template>
  <IconWrapper v-if="isFilled" name="add-group" :color="color" fillMode="fill">
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.949 14.5396C15.3802 14.5396 15 15.1034 15 17.2802C15 19.456 15.399 20 11.949 20C8.51785 20 5.58809 19.456 5.58809 17.2802C5.58809 15.1034 8.49904 14.5396 11.949 14.5396ZM6.5656 13.2292C6.5853 13.2319 6.59515 13.2464 6.59694 13.2545C6.59962 13.268 6.59425 13.2878 6.56918 13.3022C5.9621 13.6039 3.61883 14.9161 3.91342 17.6827C3.92595 17.8034 3.83104 17.9061 3.71195 17.889C3.13531 17.8061 1.65163 17.4855 1.19139 16.4867C0.936203 15.9581 0.936203 15.3457 1.19139 14.817C1.49225 14.1731 2.21752 13.73 3.32156 13.512C3.84358 13.385 5.25294 13.2049 6.5656 13.2292ZM11.949 4C14.2851 4 16.1583 5.88227 16.1583 8.23285C16.1583 10.5825 14.2851 12.4666 11.949 12.4666C9.61292 12.4666 7.73974 10.5825 7.73974 8.23285C7.73974 5.88227 9.61292 4 11.949 4ZM6.33593 4.70581C6.58127 4.70581 6.81586 4.73192 7.04509 4.77875C7.07553 4.78596 7.10956 4.80127 7.12746 4.82829C7.14806 4.86251 7.13284 4.90844 7.11135 4.93816C6.43353 5.89371 6.04313 7.05909 6.04313 8.30913C6.04313 9.50694 6.4004 10.6228 7.02718 11.5504C7.09165 11.6459 7.03434 11.7747 6.92063 11.7945C6.76304 11.8224 6.60186 11.8368 6.43711 11.8413C4.79404 11.8845 3.31932 10.8209 2.91191 9.21965C2.30751 6.84114 4.07951 4.70581 6.33593 4.70581Z"
        fill="#1B1B1E"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M20 10C20.3156 10 20.5714 10.2558 20.5714 10.5714V13.4286H23.4286C23.7442 13.4286 24 13.6844 24 14C24 14.3156 23.7442 14.5714 23.4286 14.5714H20.5714V17.4286C20.5714 17.7442 20.3156 18 20 18C19.6844 18 19.4286 17.7442 19.4286 17.4286V14.5714H16.5714C16.2558 14.5714 16 14.3156 16 14C16 13.6844 16.2558 13.4286 16.5714 13.4286H19.4286V10.5714C19.4286 10.2558 19.6844 10 20 10Z"
        fill="#1B1B1E"
      />
    </svg>
  </IconWrapper>
  <IconWrapper v-else name="add-group" :color="color" fillMode="stroke">
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_2478_1445)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M11.8867 14.6641C8.67273 14.6641 5.92773 15.1511 5.92773 17.0961C5.92773 19.0401 8.65573 19.5411 11.8867 19.5411C15.1007 19.5411 15 19.0421 15 17.0961C15 15.1501 15.1177 14.6641 11.8867 14.6641Z"
          stroke="#1B1B1E"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M11.8864 11.888C13.9954 11.888 15.7054 10.179 15.7054 8.069C15.7054 5.96 13.9954 4.25 11.8864 4.25C9.77744 4.25 8.06741 5.96 8.06741 8.069C8.05944 10.171 9.75644 11.881 11.8584 11.888H11.8864Z"
          stroke="#1B1B1E"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M5.88509 10.8977C4.48909 10.7017 3.41609 9.5057 3.41309 8.0567C3.41309 6.6287 4.45409 5.4447 5.81909 5.2207"
          stroke="#1B1B1E"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M4.044 14.25C2.693 14.452 1.75 14.925 1.75 15.9C1.75 16.571 2.194 17.007 2.912 17.281"
          stroke="#1B1B1E"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M20 10C20.3156 10 20.5714 10.2558 20.5714 10.5714V13.4286H23.4286C23.7442 13.4286 24 13.6844 24 14C24 14.3156 23.7442 14.5714 23.4286 14.5714H20.5714V17.4286C20.5714 17.7442 20.3156 18 20 18C19.6844 18 19.4286 17.7442 19.4286 17.4286V14.5714H16.5714C16.2558 14.5714 16 14.3156 16 14C16 13.6844 16.2558 13.4286 16.5714 13.4286H19.4286V10.5714C19.4286 10.2558 19.6844 10 20 10Z"
          fill="#1B1B1E"
        />
      </g>
      <defs>
        <clipPath id="clip0_2478_1445">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  </IconWrapper>
</template>

<script setup lang="ts">
import IconWrapper from './wrapper/wrapper.vue'

import type { ColorsType } from '@/types'

defineProps<{
  color: ColorsType
  isFilled?: boolean
}>()
</script>
